/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { ActivePreset, useShushApp, useShushAppSelect } from "@/spa/app/app.tsx";

const LoopLabels = {
  missing: "no loop yet",
  rendering: "rendering…",
  ready: "ready",
  error: "render failed",
} as const;

export interface PlayViewProps {}
export function PlayView(props: PlayViewProps) {
  const app = useShushApp();
  const playing = useShushAppSelect((s) => s.playing);
  const volume = useShushAppSelect((s) => s.volume);
  const loop = useShushAppSelect((s) => s.loop);
  const error = useShushAppSelect((s) => s.error);
  const name = useShushAppSelect((s) => ActivePreset(s).name);

  return (
    <div class="play-view">
      <div class="play-name">{name}</div>
      <button
        type="button"
        class={playing ? "play-button playing" : "play-button"}
        disabled={loop !== "ready"}
        onClick={() => app.dispatch({ type: playing ? "stop" : "play" })}
      >
        {playing ? "stop" : "play"}
      </button>
      <label class="play-volume">
        <span>volume</span>
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={volume}
          onInput={(e) =>
            app.dispatch({
              type: "volume",
              payload: { volume: Number(e.currentTarget.value) },
            })}
        />
      </label>
      <div class="play-status">{LoopLabels[loop]}</div>
      {error && <div class="play-error">{error}</div>}
    </div>
  );
}
